import { memo } from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { formatValueWithSign } from "components/ui/formatters";
import { SingleValueCardColor, SingleValueCardType } from "constants/index";
import { SingleValueCardProps } from "helpers/types";
import EditableTextField from "./EditableTextField";

const SingleValueCard = memo(({
  value,
  label,
  description,
  type,
  color,
  onValueChange,
}: SingleValueCardProps) => {
  
  const getDisplayColor = () => {
    if (type === SingleValueCardType.PERCENTAGE) {
      if (value > 0) return SingleValueCardColor.SUCCESS;
      if (value < 0) return SingleValueCardColor.ERROR;
    }
    return color || SingleValueCardColor.PRIMARY;
  };

  const displayColor = getDisplayColor();
  const formattedValue = formatValueWithSign(value, type);

  return (
    <Card sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
      <CardContent>
        <Typography variant="h5">{label}</Typography>
        
        <EditableTextField
          value={value}
          formattedValue={formattedValue}
          type={type}
          displayColor={displayColor}
          onValueChange={onValueChange}
        />
        
        <Typography variant="body1">{description}</Typography>
      </CardContent>
    </Card>
  );
});

export default SingleValueCard;
